export interface MockUser {
  id: number;
  email: string;
  password: string; // In mock mode only - never store plain passwords in production!
  role: 'ADMIN' | 'OPS' | 'APPLICANT';
  first_name: string;
  last_name: string;
  phone?: string;
  created_at: string;
  last_login?: string;
}

// Mock users for testing different roles
export const mockUsers: MockUser[] = [
  // Admin user
  {
    id: 1,
    email: 'admin@ncaa.gov.ng',
    password: 'admin123',
    role: 'ADMIN',
    first_name: 'Admin',
    last_name: 'User',
    phone: '+234-800-NCAA-ADMIN',
    created_at: '2023-01-01T00:00:00Z',
    last_login: '2025-01-08T09:00:00Z',
  },
  // Operator user
  {
    id: 3,
    email: 'operator@ncaa.gov.ng',
    password: 'operator123',
    role: 'OPS',
    first_name: 'Operations',
    last_name: 'Manager',
    phone: '+234-800-NCAA-OPS',
    created_at: '2023-06-15T00:00:00Z',
    last_login: '2025-01-08T08:30:00Z',
  },
  // Applicant user (existing)
  {
    id: 2,
    email: 'applicant@test.com',
    password: 'applicant123',
    role: 'APPLICANT',
    first_name: 'John',
    last_name: 'Okafor',
    phone: '+234-801-234-5678',
    created_at: '2024-01-15T10:30:00Z',
    last_login: '2025-01-08T10:00:00Z',
  },
  // Additional test users
  {
    id: 4,
    email: 'admin2@ncaa.gov.ng',
    password: 'admin123',
    role: 'ADMIN',
    first_name: 'Sarah',
    last_name: 'Johnson',
    phone: '+234-800-NCAA-002',
    created_at: '2023-03-20T00:00:00Z',
    last_login: '2025-01-07T15:45:00Z',
  },
  {
    id: 5,
    email: 'ops2@ncaa.gov.ng',
    password: 'operator123',
    role: 'OPS',
    first_name: 'Michael',
    last_name: 'Chen',
    phone: '+234-800-NCAA-003',
    created_at: '2023-09-10T00:00:00Z',
    last_login: '2025-01-08T07:20:00Z',
  },
];

// Mock authentication function
export const mockLogin = (email: string, password: string): MockUser | null => {
  const user = mockUsers.find(
    (u) => u.email.toLowerCase() === email.toLowerCase() && u.password === password
  );

  if (user) {
    console.log('✅ Mock: Login successful', {
      email: user.email,
      role: user.role,
      name: `${user.first_name} ${user.last_name}`,
    });
    return { ...user, password: '' }; // Don't return password
  }

  console.log('❌ Mock: Login failed', { email });
  return null;
};

// Helper to get user by ID
export const getUserById = (id: number): MockUser | null => {
  const user = mockUsers.find((u) => u.id === id);
  return user ? { ...user, password: '' } : null;
};

// Helper to get user by role
export const getUsersByRole = (role: 'ADMIN' | 'OPS' | 'APPLICANT'): MockUser[] => {
  return mockUsers.filter((u) => u.role === role).map((u) => ({ ...u, password: '' }));
};
